import React, { useState } from "react"
import { Menu, MenuItem } from "@mui/material"
import { useTranslator } from "@/hooks"
import { Button } from "@/@core/components/mui/Button"

export const ReconciledButton = ({
  manualReconcile,
  setManualReconcile,
  setOpenUploadCompanyAttendanceCVS,
  isDisabled
}: {
  manualReconcile: boolean,
  setManualReconcile: (manualReconcile: boolean) => void,
  setOpenUploadCompanyAttendanceCVS: (openUploadCompanyAttendanceCVS: boolean) => void,
  isDisabled: boolean
}) => {
  const { __ } = useTranslator()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleImportFileReconcile = () => {
    setOpenUploadCompanyAttendanceCVS(true)
    handleClose()
  }

  const handleManualReconcile = () => {
    console.log('manualReconcile', manualReconcile)
    setManualReconcile(true)
    handleClose()
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        startIcon={<i className="tabler-upload text-white" />}
        endIcon={<i className="tabler-chevron-down text-white" />}
        disabled={isDisabled}
      >
        {__('Reconlice')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          borderRadius: 2,
          mt: 1,
          minWidth: 200
        }}
      >
        <MenuItem onClick={handleImportFileReconcile} className="rounded-full">
          {__('Import File Reconcile')}
        </MenuItem>
        <MenuItem onClick={handleManualReconcile} className="rounded-full">
          {__('Manual Reconcile')}
        </MenuItem>
      </Menu>
    </>
  )
}
